import { green, grey, orange, red } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

const ColorsTheme = createTheme({
  palette: {
    success: {
      main: green[800],
    },
    error: {
      main: red[700],
    },
    warning: {
      main: orange[900],
    },
    textSecondary: {
      main: grey[700],
    },
    secondary: {
      main: grey[700],
    },
  },
})

// SvgIconPropsColorOverrides
export default ColorsTheme
